export class RedoCancelReactionSetRequest {
    reactionSetsToBeCancelled: Array<string>;
    reactionSetsToBeRepeated: Array<string>;
    reactionSetProtocolsToBeUpdated: Array<ReactionSetProtocol>;
    reactionSetVolumesToBeUpdated:Array<ReactionSetUsedSampleVolume>;
    orderId: string;
    genomicsOrderRef: string;
    constructor() {
        this.reactionSetsToBeCancelled = [];
        this.reactionSetsToBeRepeated = [];
        this.reactionSetProtocolsToBeUpdated = [];
    }

}

export class ReactionSetProtocol{
    reactionSetId: string;
    protocol: string;
}
export class ReactionSetUsedSampleVolume {
  reactionSetId: string;
  volume: number;
}
